import { useField } from 'formik';
import { KoobRichTextEditor } from '@koob/ui';
import { FormField, FormLabel, ErrorMessageWrapper } from 'ui/forms';

const EditorField = ({ label, name, ...props }) => {
  const [field, meta, helpers] = useField(name);
  const hasError = Boolean(meta.touched) && Boolean(meta.error);

  return (
    <FormField>
      {label && <FormLabel>{label}</FormLabel>}

      {/* A new name mounts a new editor, so Quill can't write the old value to it. */}
      <KoobRichTextEditor
        key={name}
        {...props}
        value={field.value}
        onChange={helpers.setValue}
        onBlur={() => helpers.setTouched(true)}
        hasError={hasError}
      />

      {hasError && <ErrorMessageWrapper>{meta.error}</ErrorMessageWrapper>}
    </FormField>
  );
};

export default EditorField;
